module.exports = __webpack_public_path__ + "static/media/mode-533.86ce9693.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-533.svg
// module id = 1069
// module chunks = 2